import {getLoginError, setSession} from '../reducers/session';
import {setProjectId} from '../reducers/project-state';
import OSS from 'ali-oss/lib/browser';

let accessToken = null;
let refreshToken = null;
let ossAccessKeyId = null;
let ossAccessKeySecret = null;
let ossSecurityToken = null;

const api = {
    async protectedRequest (url, method = 'GET', data = null) {
        const headers = {};
        if (accessToken !== null) {
            Object.assign(headers, {
                Authorization: `Bearer ${accessToken}`
            });
        }

        const init = {
            method: method,
            credentials: 'include',
            headers
        };

        if (data !== null) {
            init.body = JSON.stringify(data);
        }

        const response = await fetch(url, init);

        if (!response.ok) {
            if (response.status === 401) {
                // 其实这个时候已经拿到了，可以更新sts的数据；
                const partialData = await response.json();
                if (partialData.stsAccessId) {
                    ossAccessKeyId = partialData.stsAccessId;
                    ossAccessKeySecret = partialData.stsSecret;
                    ossSecurityToken = partialData.stsToken;
                }

                // 尝试使用 refresh token 刷新 access token
                try {
                    await api.refreshAccessToken();
                } catch (err) {
                    const error = new Error('Unable to refresh access token, check server log.');
                    error.status = response.status;
                    error.data = partialData;
                    throw error;
                }
                const newHeaders = {
                    Authorization: `Bearer ${accessToken}`
                };
                const newInit = {
                    method: method,
                    credentials: 'include',
                    newHeaders
                };
                // 重新发送请求
                return (await fetch(url, newInit)).json();
            }
            // 这个地方应该考虑直接登出
            throw new Error('Unable to refresh access token, check server log.');
        }

        return response.json();
    },

    // 定义用于刷新 access token 的函数
    async refreshAccessToken () {
        const response = await fetch('/api/token/refresh/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include' // 必须带上这个选项，浏览器会自动携带 Cookie
            // body: JSON.stringify({refresh: refreshToken})
        });

        if (!response.ok) {
            throw new Error('Unable to refresh access token, check server log.');
        }

        const data = await response.json();
        accessToken = data.access;
    },

    // eslint-disable-next-line require-await
    get_login_info (resolve, reject) {
        const request = api.protectedRequest('/api/scratch/login_info');
        request.then(data => {
            if (data) {
                if (data.stsAccessId) {
                    ossAccessKeyId = data.stsAccessId;
                }
                if (data.stsSecret) {
                    ossAccessKeySecret = data.stsSecret;
                }
                if (data.stsToken) {
                    ossSecurityToken = data.stsToken;
                }
            }
            if (resolve) {
                if (!data || data.userId === null) {
                    resolve({
                        session: false,
                        user: {
                            userId: -1,
                            username: null
                        },
                        lastProjectId: null
                    });
                } else {
                    resolve({
                        session: true,
                        user: {
                            userId: data.userId,
                            username: data.usernameForDisplay
                        },
                        lastProjectId: data.lastProjectId,
                        AccessKeyId: data.stsAccessId,
                        AccessKeySecret: data.stsSecret,
                        SecurityToken: data.stsToken
                    });
                }
            }
        })
            .catch(err => {
                if (err && err.data) {
                    if (err.data.stsAccessId) {
                        ossAccessKeyId = err.data.stsAccessId;
                    }
                    if (err.data.stsSecret) {
                        ossAccessKeySecret = err.data.stsSecret;
                    }
                    if (err.data.stsToken) {
                        ossSecurityToken = err.data.stsToken;
                    }
                }
                if (reject) reject(err);
            });
    },

    async updateProjectThumbnail (projectId, blob) {
        const headers = {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Disposition': `attachment; filename="${projectId}.png"`
        };

        const options = {
            method: 'POST',
            credentials: 'include',
            body: blob,
            headers
        };

        const url = `/api/scratch/projecthumbnail/${projectId}`;

        let response = await fetch(url, options);

        if (!response.ok) {
            if (response.status === 401 && refreshToken) {
                // 尝试使用 refresh token 刷新 access token
                await api.refreshAccessToken();
                const newHeaders = {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Disposition': `attachment; filename="${projectId}.png"`
                };
                const newInit = {
                    method: 'POST',
                    credentials: 'include',
                    body: blob,
                    newHeaders
                };
                // 重新发送请求
                response = await fetch(url, newInit);
                return response.json();
            }

            // 这个地方应该考虑直接登出
            throw new Error('Unable to refresh access token, check server log.');
        }

        return response.json();
    },

    async login (dispatch, username, password, isShowingWithId) {
        const data = {
            username: username,
            password: password,
            login: true
        };
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Login': true
            },
            body: JSON.stringify(data)
        };

        await fetch('/api/scratch/login', options)
            .then(response => {
                if (!response.ok) {
                    throw new Error('请检查用户名/密码');
                }

                return response.json();
            })
            .then(responseData => {
                if (responseData) {
                    if (responseData.access) {
                        accessToken = responseData.access;
                    }
                    if (responseData.refresh) {
                        refreshToken = responseData.refresh;
                    }
                    if (responseData.stsAccessId) {
                        ossAccessKeyId = responseData.stsAccessId;
                    }
                    if (responseData.stsSecret) {
                        ossAccessKeySecret = responseData.stsSecret;
                    }
                    if (responseData.stsToken) {
                        ossSecurityToken = responseData.stsToken;
                    }
                }

                // if (!isShowingWithId) {
                //     dispatch(setProjectId(responseData.lastProjectId));
                // }

                dispatch(setSession({
                    session: true,
                    user: {
                        userId: responseData.userId,
                        username: responseData.usernameForDisplay
                    }
                }));
                // dispatch(onSetProjectOwner(responseData.usernameForDisplay));
                // TODO，这里不对，如果当前已经打开了某个project了，我们不应该redirect去上一次的project
                // if current hash is null :


            })
            .catch(error => {
                dispatch(getLoginError(error));
            });
    },

    fetch_my_projects (resolve, reject) {
        const request = api.protectedRequest('/api/scratch/my_projects/');
        request.then(data => resolve(data))
            .catch(err => reject(err));

    },

    logout: cleanup => {

        accessToken = null;
        refreshToken = null;

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        fetch('/api/logout', options)
            .finally(cleanup);
    },

    createOssClient: () => new OSS({
        region: 'oss-cn-shenzhen',
        bucket: 'cubicbird-scratch',
        accessKeyId: ossAccessKeyId,
        accessKeySecret: ossAccessKeySecret,
        stsToken: ossSecurityToken,
        refreshSTSToken: async () => {
            await api.get_login_info();
            return {
                accessKeyId: ossAccessKeyId,
                accessKeySecret: ossAccessKeySecret,
                stsToken: ossSecurityToken
            };
        },
        refreshSTSTokenInterval: 1200000
    }),

    uploadAsset: async (asset, data) => {
        const ossClient = api.createOssClient();
        const options = {
            // mime: 'json',
            // headers: {'Content-Type': 'text/plain'}
        };
        const rest = await ossClient.put(`asset/${asset}`, data, options);
        return rest;
    },

    getAssetUrlForGet: (asset, type = 'asset') => {
        // if (!ossAccessKeyId) {
        //     return '';
        // }
        // const ossClient = api.createOssClient();
        // return ossClient.signatureUrl(`${type}/${asset}`);

        return `https://sb3assets.cubicbird.com/${type}/${asset}`;
    },

    getAssetUrlForPost: asset => api.getAssetUrlForGet(asset)


};

export default api;
